/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function () {
  function wrapRegisteredMarks(root = document) {
    const elements = root.querySelectorAll(
      'h1, h2, .h1, .h2, .primary-nav__link, .secondary-nav__link, .mega-links__link'
    );

    elements.forEach(function (element) {
      if (!element.textContent.includes('®')) return;

      element.childNodes.forEach(function (node) {
        if (
          node.nodeType !== Node.TEXT_NODE ||
          !node.nodeValue.includes('®')
        ) {
          return;
        }

        const fragment = document.createDocumentFragment();
        const parts = node.nodeValue.split('®');

        parts.forEach(function (part, index) {
          fragment.appendChild(document.createTextNode(part));

          if (index < parts.length - 1) {
            const mark = document.createElement('sup');
            mark.className = 'plumager-registered-mark';
            mark.textContent = '®';
            fragment.appendChild(mark);
          }
        });

        node.replaceWith(fragment);
      });
    });
  }

  wrapRegisteredMarks();

  const observer = new MutationObserver(function () {
    wrapRegisteredMarks();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});